<template>
  <div class="main block3">
    <div class="main_bg">
      <div>
        <contentMenu :index="1"></contentMenu>
      </div>
      <div class="banner">
        <img :src="imageurlMobile" style="width: 100%" />
      </div>
      <div class="main-content">
        <div class="image-content">
          <el-carousel
            type="card"
            indicator-position="none"
            :autoplay="false"
            arrow="always"
            style="width: 100%;"
            height="110px"
          >
            <el-carousel-item v-for="(item,index) in lbList" :key="index">
              <img :src="item.imageurlMobile" style="width: 100%" @click="showPop(item)" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="main2-content">
        <contentLeft :list="list[0]" :isIconShow="false" isSubShow isSubEnShow isDecEnShow></contentLeft>
        <contentLeft :list="list[1]" :isIconShow="false" isSubShow isSubEnShow isDecEnShow></contentLeft>
        <contentLeft :list="list[2]" :isIconShow="false" isSubShow isSubEnShow isDecEnShow></contentLeft>
        <contentLeft :list="list[3]" :isIconShow="false" isSubShow isSubEnShow isDecEnShow></contentLeft>
      </div>
      <div class="main-content">
        <div class="title-content">
          <div class="line"></div>
          <div class="title">最新资讯</div>
        </div>
        <!-- <contentLeft :list="list2[0]" isBtnShow></contentLeft> -->
        <div class="layout-flex">
          <div class="item-video">
            <img class="image" :src="list2[0].imageurlMobile" style="width:100%" />
          </div>
          <div class="item-title" @click="aaa">
            <div class="item-line">{{list2[0].title}}</div>
          </div>
          <div class="item-dec" v-html="list2[0].dec"></div>
        </div>
      </div>
    </div>

    <div class="cover" v-if="showCover"></div>
    <div class="popup" v-if="showCover">
      <div>
        <div class="close" @click="closePop()">
          <img alt="xxx" src="../../assets/meb/imgs/closeIcon@2x.png" style="width: 100%;" />
        </div>
        <div class="img">
          <img :src="showImg" style="width: 100%;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config";
import contentMenu from "./contentMenuMobile.vue";
import contentLeft from "./contentLeftMobile.vue";
import contentRight from "./contentRightMobile.vue";
export default {
  components: {
    contentMenu,
    contentLeft,
    contentRight
  },
  data() {
    return { ...config.scene, showCover: false, showImg: "" };
  },
  mounted() {
    console.log(this);
  },
  methods: {
    aaa() {
      window.open(
        "https://www.csvw.com/csvw-website/news/company-news.html?newsid=2876",
        "_target"
      );
    },
    showPop(item) {
      this.showCover = true;
      this.showImg = item.imageurlbig;
    },
    closePop() {
      this.showCover = false;
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 375px;
  margin: 0px auto;
  font-size: 14px;
}

.main_bg {
  width: 100%;
  min-width: 375px;
  background: #ffffff;
}

.main-content {
  width: calc(100% - 0px);
  margin: 0px 0px;

  .image-content {
    width: 375px;
    margin-left: auto;
    margin-right: auto;
    padding: 20px 0px;
    box-sizing: border-box;
  }

  .title-content {
    width: 375px;
    padding: 20px 10px;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }

  .title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 24px;
    font-weight: 400;
    color: #0077c8;
    background: #ffffff;
    padding: 0px 30px;
  }
  .line {
    width: 355px;
    height: 2px;
    background: #cccccc;
  }

  .layout-flex {
    width: 375px;
    padding: 20px 10px 20px 10px;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    .item-line {
      float: left;
      border-bottom: 3px solid rgba(40, 132, 244, 0.2);
    }
    .item-title {
      margin-top: 25px;
      height: 30px;
      line-height: 16px;
      font-size: 16px;
      font-weight: 400;
      color: #0077c8;
    }
    .item-dec {
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
      margin-top: 16px;
    }
    .item-video {
    }
  }
}

.block3 .cover {
  position: fixed;
  /*首先将位置固定住*/
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /*上下左右设置都为0*/
  background: rgba(2, 2, 2, 0.5);
  z-index: 8;
}
.block3 .popup {
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 90px;
  bottom: 0;
  width: 355px;
  z-index: 9;
}
.block3 .popup .close {
  position: relative;
  float: right;
  width: 20px;
  cursor: pointer;
}

.main2-content {
  width: calc(100% - 0px);
  margin: 0px 0px;
  background-image: url("../../assets/meb/imgs/xczj/xczjBg@2x.png");
  background-size: 100% 100%;
  background-repeat-x: no-repeat;
}
.divHeight {
  height: 23px;
}
</style>
